import { render, staticRenderFns } from "./thrideServerForm.vue?vue&type=template&id=140bc45f"
import script from "./thrideServerForm.vue?vue&type=script&lang=js"
export * from "./thrideServerForm.vue?vue&type=script&lang=js"
import style0 from "./thrideServerForm.vue?vue&type=style&index=0&id=140bc45f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports